import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  EnergyUsageFuelType,
  EnergyUsageGranularity,
} from "@/api/backofficeRest/generated/model"
import { EnergyUsage } from "./energyUsage"
import { IEnergyUsage } from "./energyUsage.types"
import dayjs from "dayjs"

export interface IEnergyUsageValueRaw {
  startDate: string
  endDate: string
  kwh?: number | null
  cost?: number | null
}

export interface IEnergyUsageRaw {
  meterpointId: number
  registerId: number
  rateName: string
  fuelType: EnergyUsageFuelType
  granularity: EnergyUsageGranularity
  startDate: string
  endDate: string
  values: Array<IEnergyUsageValueRaw | null>
}

export const EnergyUsageParser: IParser<IEnergyUsage, IEnergyUsageRaw> = {
  toDomain: (data) => {
    try {
      const values = data.values
        .filter((v) => !!v)
        .map((v) => ({
          startDate: dayjs(v.startDate),
          endDate: dayjs(v.endDate),
          cost: v.cost ?? null,
          kwh: v.kwh ?? null,
        }))

      return new EnergyUsage({
        meterpointId: data.meterpointId,
        registerId: data.registerId,
        rateName: data.rateName,
        fuelType: data.fuelType,
        granularity: data.granularity,
        startDate: dayjs(data.startDate),
        endDate: dayjs(data.endDate),
        values,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
